import {
  MODAL_INTERACTION,
  MODAL_HIDDEN,
  MODAL_DATA_LOADED,
} from '../actions/constants';
import { MODAL_ADD_ALERT } from '../util/enums/EnumModals';
import ModalAddAlert, {
  DAILY,
  NEW_RESULTS,
} from '../components/modals/ModalAddAlert';
import { deserialiseViews } from './views';
import { ZAPIER } from '../util/AlertRef';

const INITIAL_STATE = {
  existing: null, // AlertRef if editing existing
  allViews: null, // list of [ViewRef, email] array objs
  allRecipients: null, // list of email addresses (strings)
  search: '',
  chosen: null, // ViewRef
  frequency: DAILY,
  trigger: NEW_RESULTS,
  triggerType: null, // string: zapier or email
  showChanged: false,
  chosenRecipients: [], // list of strings (emails)
};

function interaction(state, payload) {
  switch (payload.section) {
    case 'search': {
      return { ...state, search: payload.value };
    }
    case 'insightChosen':
      return { ...state, chosen: payload.view };
    case 'frequency':
      return { ...state, frequency: payload.value };
    case 'show-changed': {
      return { ...state, showChanged: payload.value === 'changed' };
    }
    case 'toggleEmail': {
      return {
        ...state,
        chosenRecipients:
          state.chosenRecipients.indexOf(payload.email) === -1
            ? [...state.chosenRecipients, payload.email] // add email
            : state.chosenRecipients.filter((email) => email !== payload.email), // remove email
      };
    }
    default:
      return state;
  }
}

const isReadyForSave = (newState) => {
  return (
    newState.chosen &&
    (newState.triggerType === ZAPIER || newState.chosenRecipients.length > 0)
  );
};

const modalAddAlert = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case MODAL_INTERACTION: {
      if (action.payload.modalType !== MODAL_ADD_ALERT) {
        return state;
      }
      const newState = interaction(state, action.payload.props);
      newState.readyForSave = isReadyForSave(newState);
      return newState;
    }
    case MODAL_DATA_LOADED:
      if (action.payload.modal === ModalAddAlert) {
        let newState = {
          ...INITIAL_STATE,
          allViews: deserialiseViews(action.payload.listOfViews._views),
          allRecipients: action.payload.meta._emails.sort(),
          triggerType: action.payload.triggerType,
        };
        if (action.payload.existing) {
          // editing existing
          return {
            ...newState,
            existing: action.payload.existing,
            chosen: newState.allViews
              .map((pair) => pair[0])
              .find((v) => v.series() === action.payload.meta._viewSeries),
            frequency: action.payload.meta._frequency,
            trigger: action.payload.meta._trigger,
            triggerType: action.payload.existing.triggerType(),
            showChanged: action.payload.meta._showChanged,
            chosenRecipients: action.payload.meta._chosenRecipients,
          };
        }
        if (action.payload.view) {
          const chosen = newState.allViews
            .map((pair) => pair[0])
            .find((v) => v.series() === action.payload.view.series());
          const chosenRecipients = newState.allRecipients.filter(
            (email) => email === action.payload.userEmail,
          );
          newState = {
            ...newState,
            chosen,
            chosenRecipients,
          };
        }
        return { ...newState, readyForSave: isReadyForSave(newState) };
      }
      return state;
    default:
      return state;
  }
};

export default modalAddAlert;
